import { render, staticRenderFns } from "./RoleBasedAccessControlDashboardList.vue?vue&type=template&id=5bd10f7f&scoped=true"
import script from "./RoleBasedAccessControlDashboardList.vue?vue&type=script&lang=js"
export * from "./RoleBasedAccessControlDashboardList.vue?vue&type=script&lang=js"
import style0 from "./RoleBasedAccessControlDashboardList.vue?vue&type=style&index=0&id=5bd10f7f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd10f7f",
  null
  
)

export default component.exports